<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    {{ data.message }}
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onClick()" class="btn_green" cdkFocusInitial>
        OK
    </button>
</div>